import { render, staticRenderFns } from "./TimeTplDetail.vue?vue&type=template&id=57a5a128&scoped=true&"
import script from "./TimeTplDetail.vue?vue&type=script&lang=js&"
export * from "./TimeTplDetail.vue?vue&type=script&lang=js&"
import style0 from "./TimeTplDetail.vue?vue&type=style&index=0&id=57a5a128&lang=less&scoped=true&"
import style1 from "./TimeTplDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5a128",
  null
  
)

export default component.exports